import { render, staticRenderFns } from "./Menu_editor.vue?vue&type=template&id=5c9f4344"
import script from "./Menu_editor.vue?vue&type=script&lang=js"
export * from "./Menu_editor.vue?vue&type=script&lang=js"
import style0 from "./Menu_editor.vue?vue&type=style&index=0&id=5c9f4344&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports